export default "__VITE_ASSET__CnjFRccz__"